import { render } from "./NZTermsMobileGen2.vue?vue&type=template&id=7f0152da&scoped=true&ts=true"
import script from "./NZTermsMobileGen2.vue?vue&type=script&lang=ts"
export * from "./NZTermsMobileGen2.vue?vue&type=script&lang=ts"

import "./NZTermsMobileGen2.vue?vue&type=style&index=0&id=7f0152da&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/rontend-vue_version_release-euau/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f0152da"]])

export default __exports__